import { CircularProgress } from '@mui/material'

const LoadingButtonIcon = () => {
  return (
    <CircularProgress style={{ width: '20px', height: '20px' }}/>
  )
}

export default LoadingButtonIcon
